import React from "react";
import { ButtonBase } from "@reusejs/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { useRouter } from "next/router";
import Link from "next/link";
import { useSelector, useDispatch } from "react-redux";
import { setTokens, setUser, clearTempToken, clearGuestUser } from "store";
import { getUser, updateUser, checkAndUpdateBidder } from "services";

export default function VerificationSuccess() {
  const router = useRouter();
  const dispatch = useDispatch();
  const tempToken = useSelector((state: any) => {
    return state.auth.tempToken;
  });
  const guestUserName = useSelector((state: any) => {
    return state.auth.guestUser.name;
  });
  const redirectUrl = useSelector((state: any) => {
    return state.auth.redirectUrl;
  });

  const handleLogin = async () => {
    if (tempToken) {
      dispatch(setTokens({ access_token: tempToken }));

      await updateUser({
        bio: {
          full_name: guestUserName,
        },
      });

      await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken: { access_token: tempToken } }),
      });

      const user: any = await getUser();
      const validateBidderEmail = await checkAndUpdateBidder(
        user?.attributes[0]?.value,
        user.uuid
      );

      dispatch(setUser(user));
      dispatch(clearTempToken());
      dispatch(clearGuestUser());
      if (redirectUrl) {
        router.push(redirectUrl);
      } else {
        router.push("/");
      }
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-20 xl:px-24 flex">
      <div className="mx-auto w-full max-w-md lg:w-96 ">
        <div>
          <div>
            <div className="flex justify-center lg:justify-start">
              <CheckCircleIcon
                height={30}
                width={30}
                className="text-blue-700"
              />
            </div>
            <h2 className="text-center lg:text-left mt-6 text-3xl font-semibold text-gray-900 tracking-tight">
              Email verified
            </h2>
            <p className="text-center lg:text-left mt-3 text-base text-gray-600">
              Your account has been created with Auction Bazaar.Click below to
              log in magically.
            </p>
          </div>
          <div className="mt-4">
            <ButtonBase
              variant="primary"
              type="submit"
              label="Continue"
              onClick={() => {
                handleLogin();
                // router.push("/");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
              }}
            />
          </div>
          <div className="py-5 bg-blue-gray-50">
            <Link href="/login">
              <a className="text-sm font-medium text-gray-500 hover:text-blue-700">
                <span aria-hidden="true">&larr; </span>Back to log in
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
